import React from "react";

import { HvBanner, HvBannerProps } from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";

const Banner: React.FC<HvBannerProps> = (props) => {
  const classes = useStyles();

  return <HvBanner offset={54} classes={{ root: classes.root }} {...props} />;
};

export default Banner;
